module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shinai-12b654418ecd54f4f21f0ab8e4d38a88.png";